import React from "react";
import "./BalanceSheet.scss";
import balanceSheetCapital from "../../../assets/Reports/balance-sheet2025_1.png";
import balanceSheetProperty from "../../../assets/Reports/balance-sheet2025_2.png";

const BalanceSheet = () => {
  return (
    <>
      <div className="balance_sheet">
        <div className="container">
          <div className="heading_box">Balance Sheet</div>
          <div className="my-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-12 mb-3 mb-lg-0">
                <img src={balanceSheetCapital} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-lg-0">
                <img src={balanceSheetProperty} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BalanceSheet;
